import { Link, Navigate } from "react-router-dom";
import React, { Component } from "react";
import AuthField from "../AuthField/AuthField";
import AuthWindow from "../AuthWindow/AuthWindow";
import { Alert } from "../../Component/Alert";
import { GoogleLogin } from "react-google-login";
const { NotificationManager } = require("react-notifications");
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import "../Passport.css";
import { GOOGLE_CLIENT_ID } from "../../constants/auth";

class LoginForm extends Component<any, any> {
    emailRef: any;
    passwordRef: any;

    constructor(props: any) {
        super(props);

        this.state = {
            emailError: "",
            passwordError: "",
            statusMessage: props.statusMessage
        };

        this.emailRef = React.createRef();
        this.passwordRef = React.createRef();

        this.googleResponse = this.googleResponse.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    static getDerivedStateFromProps(props: any, state: any) {
        state.statusMessage = props.statusMessage;
        return state;
    }

    onFailure = (err: string) => {
        NotificationManager.error(
            "Click to Dismiss",
            `Could not login with google because ${err}`,
            5000
        );
    };

    googleResponse = (res: any) => {
        this.props.processGoogleResponse(res);
    };

    handleSubmit(ev: React.FormEvent<HTMLFormElement>) {
        ev.preventDefault();

        var email = this.emailRef.current!.value;
        var password = this.passwordRef.current!.value;

        this.setState({
            emailError: "",
            passwordError: ""
        });

        var errors: boolean = false;

        if (email.length < 5) {
            this.setState({
                emailError: "Email is not long enough"
            });
            errors = true;
        }

        if (password.length < 8) {
            this.setState({
                passwordError: "Password is not long enough"
            });
            errors = true;
        }

        if (!errors) {
            this.props.handleSubmit(email, password);
        }
    }

    render() {
        if (this.props.isLoggedIn) {
            return <Navigate to="/" />;
        }
        return (
            <AuthWindow
                image="/images/adult-art-character-1333304.jpg"
                source_url="https://www.pexels.com/photo/red-and-multicolored-figure-1333320/?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels"
                author="Magda Ehlers"
                author_url="https://www.pexels.com/@magda-ehlers-pexels?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels"
            >
                <Grid container justifyContent="center">
                    <Grid container item xs={12} sm={12} md={4}>
                        <Card>
                            <div className="form-half">
                                <h1>
                                    Log in to Learn
                                </h1>
                                <GoogleLogin
                                    clientId={
                                        GOOGLE_CLIENT_ID
                                    }
                                    buttonText="Sign in with Google"
                                    onSuccess={this.googleResponse}
                                    onFailure={this.onFailure}
                                    cookiePolicy={"single_host_origin"}
                                />
                                <br />
                                <br />
                                <form
                                    onSubmit={this.handleSubmit}
                                    method="POST"
                                >
                                    <Grid container spacing={2}>
                                        <Grid container item xs={12}>
                                            <AuthField
                                                label="Email"
                                                ref={this.emailRef}
                                                error={this.state.emailError}
                                                reference="email"
                                            />
                                        </Grid>
                                        <Grid container item xs={12}>
                                            <AuthField
                                                label="Password"
                                                ref={this.passwordRef}
                                                error={this.state.passwordError}
                                                reference="password"
                                            />
                                        </Grid>{" "}
                                        <Grid container item xs={12}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                            >
                                                Login
                                            </Button>
                                            <Alert
                                                status={this.props.status}
                                                message={
                                                    this.state.statusMessage
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                                <hr />
                                <span>
                                    Need an account?{" "}
                                    <Link to="/signup">Signup</Link>
                                </span>
                                <span className="pull-right">
                                    <Link to="/forgot">Forgot Password?</Link>
                                </span>
                                <br />
                                <span>
                                    Or go <Link to="/">home</Link>
                                </span>
                            </div>
                        </Card>
                    </Grid>
                </Grid>
            </AuthWindow>
        );
    }
}

export default LoginForm;
